import type { FC, ReactNode } from 'react'
import useBreakpoint, { type Breakpoint } from '../../hooks/useBreakpoint'

interface HiddenProps {
  children?: ReactNode
  minBreakpoint?: Breakpoint
  maxBreakpoint?: Breakpoint
}

const Hidden: FC<HiddenProps> = ({ children, minBreakpoint, maxBreakpoint }) => {
  const isMatch = useBreakpoint({
    minBreakpoint,
    maxBreakpoint,
  })

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isMatch ? null : <>{children}</>
}

export default Hidden
